import { add } from "lodash";

const baseUrls = {
  // main: 'http://localhost:3011/v1/api',
  main: 'https://saas.glueple.com:3011/v1/api',
  // main: 'https://glueple.com:3011',
  chat: '',
}
const apiUrls = {
  // auth: {
  //   login: `employee/emplogin`,
  //   generateAuthToken: '/auth/token',
  //   generateAccessTokenOrLogin: '/access/token',
  // },
  auth: {
    login: `login`,
    logout: `logout`,
    resetPassword: `reset-password`,
    forgotPassword: "forgot-password",
    sendOtp: 'send-otp',
    verifyOtp: 'verify-otp',
    forgotPasswordForAdmin: 'forgot-password-for-admin',
    switchAccounts: "switch-accounts"
  },
  common: {
    getAppConstantData: `get-app-constants`,
    getDateConstant: `get-date-constant`,
    getConstantByCategorySubcategory: `get-constant-by-category-subcategory`,
    checkInCheckOutMachine: `check-in-check-out-machine`
  },
  admin: {
    //department
    getAllDepartment: `get-departments`,
    getDepartmentList: `get-department-list`,
    createDepartment: `create-department`,
    updateDepartment: `update-department`,
    deleteDepartment: `delete-department`,

    createSubDepartment: `create-sub-department`,
    getSubDepartment: `get-sub-department`,
    updateSubDepartment: `update-sub-department`,
    getAllSubDepartmentList: `get-all-sub-department`,
    getSubDepartmentByDepartment: `get-sub-department-by-department`,

    createProject: `create-project`,
    getProject: `get-project`,
    updateProject: `update-project`,
    getAllProjectList: `get-all-project`,

    createSkill: `create-skill`,
    getSkill: `get-skill`,
    updateSkill: `update-skill`,
    getAllSkillList: `get-all-skill`,

    assignProject: `assign-project`,
    getAssignProject: `get-assign-project`,
    assignSkill: `assign-skill`,
    getAssignSkill: `get-assign-skill`,

    //designation
    getDesignations: `get-designations`,
    getAllDesignation: `get-all-designation`,
    getDesignationsByDepartment: `get-designation-by-department`,
    createDesignation: `create-designation`,
    updateDesignation: `update-designation`,
    deleteDesignation: `delete-designation`,

    //Position
    createPosition: `create-position`,
    getPositionByDepartmentDesignation: `get-position-by-department-designation`,
    getAllPositions: `get-all-positions`,
    updatePosition: `update-position`,
    deletePosition: `delete-position`,


    //Qualification
    addQualification: `add-qualification`,
    getAllQualification: `get-qualifications`,
    getAllQualificationsByParentId: 'get-qualifications-by-parent-id',
    updateQualification: 'update-qualification',
    deleteQualification: 'delete-qualification', 


    //trainingCertificate
    addTrainingCertificate: `add-training-certificates`,
    getTrainingCertificates: `get-training-certificates`,
    updateTrainingCertificate: `update-training-certificates`,
    deleteTrainingCertificate: `delete-training-certificates`,
    getAllTrainingCertificates: `get-all-training-certificates`,


    //email Template 
    createEmailType: `create-email-type`,
    getEmailType: `get-email-type`,
    createEmailTemplate: `create-email-template`,
    getEmailTemplate: `get-email-template`,
    updateEmailTemplate: `update-email-template`,
    deleteEmailtemplate: `delete-email-template`,
    removeImageTemplate: `remove-template-image`,
    addActionTemplate: `add-action-template`,
    getActionTemplate: `get-action-template`,
    getActionType: `get-action-type`,
    UpdateAction: `update-action`,
    deleteAction: `delete-Action`,

    //leave 
    addLeaveType: `add-leave-type`,
    getAllLeaveTypes: `get-leave-type`,
    updateLeaveType: `update-leave-type`,
    deleteLeaveType: `delete-leave-type`,
    addLeaveSetting: `/add-leave-setting`,
    getAllLeaveSetting: `get-all-leave-setting`,
    getLeaveSettingByLeaveId: `get-leave-setting-by-leave-id`,
    updateLeaveSetting: `update-leave-setting`,
    deleteLeaveSetting: `delete-leave-setting`,
    getLeaveConstantData: `get-leave-constants`,
    getLeaveTypeList: `get-leave-type-list`,
    applyLeave: `apply-leave`,
    getLeaveBalance: `get-leave-balance`,
    getEmployeeAppliedLeave: `get-employee-applied-leave`,
    approveRejectLeave: 'approve-reject-leave',
    cancelLeave: `cancel-Leave`,
    getEmployeeApprovelLeave: `get-employee-approvel-leave`,
    getAllEmployeeLeave: `get-all-employee-leave`,
    getLeaveProgress: `get-leave-progress`,
    sandwichLeavesDates: `sandwich-leaves-dates`,
    getMonthlyAttendance: `get-monthly-attendance`,
    creditDebitLeave: `credit-debit-leave`,
    getCreditDebitLeave: `get-credit-debit-leave`,


    //Policies Url
    createPolicyCategory: `create-policy-category`,
    getAllPolicyCategorys: `get-policy-category`,
    updatePolicyCategory: `update-policy-category`,
    deletePolicyCategory: `delete-policy-category`,
    createPolicy: `create-policy`,
    getAllPolicy: `get-policies`,
    getPolicyByCategoryId: `get-policy-by-category-id`,
    updatePolicy: `update-policy`,
    deletePolicy: `delete-policy`,
    acceptPolicyByUser: `accept-policy-by-user`,
    getPolicyCategoryList: `get-policy-category-list`,
    getPolicyList: `get-policy-list`,
    getClientTermsAndConditions: `get-client-terms-and-conditions`,
    sendOtpVerification: `send-otp-verification`,
    verifyClientTermsOTP: `verify-client-terms-otp`,
    acceptAndRejectClientTerms: `accept-reject-client-terms`,

    //Attendance DashBoard Api
    checkInCheckOut: `check-in-check-out`,
    getCheckInCheckOut: `get-check-in-check-out`,
    getAttendanceSummary: `get-attendance-summary`,
    getAttendanceDashboard: `get-attendance-dashboard`,


    //Permission Url
    createPermission: 'create-permission',
    addAccessRoute: 'add-access-route',
    getAllRoutes: 'get-all-routes',
    getRoutesPermission: 'get-routes-permission',
    getMenuPermission: 'get-menu-permission',
    getMenuRoutesPermission: 'get-menu-routes-permission',
    getPermissionConstant: 'get-permission-constant',
    getCategoryWisePermission: `get-category-wise-permission`,
    updatePermission: `update-permission`,
    getRoleOrUserWisePermission: `get-role-user-wise-permission`,

    //Approval Management
    createApprovalHierarchy: `create-approval-hierarchy`,
    getHierarchy: `get-hierarchy`,
    updateHierarchy: `update-hierarchy`,
    deleteHierarchy: `delete-hierarchy`,

    // financial Year 
    createFinancialYear: `add-financial-year`,
    updateFinancialYear: `update-financial-year`,
    getAllFinancialYears: `get-all-financial-year`,
    getFinancialYearList: `get-financial-year-list`,
    getFinancialYearWiseMonth: `get-financial-year-wise-month`,


    addProjectType: `add-project-type`,
    getProjectType: `get-project-type`,
    updateProjectType: `update-project-type`,
    getAllProjectTypeList: `get-all-project-type`,
    deleteProjectType: `delete-project-type`,

    addProjectCategory: `add-project-category`,
    getProjectCategory: `get-project-category`,
    updateProjectCategory: `update-project-category`,
    getAllProjectCategoryList: `get-all-project-category`,
    deleteProjectCategory: `delete-project-category`,


    getAllQuestion: 'get-all-question',
    getMastersCounts: 'get-masters-counts',
    getDropDownMaster: 'get-drop-down-master'

  },
  community: {
    createPost: `create-post`,
    updatePost: `update-post`,
    deletePost: `delete-post`,
    getAllPost: `get-all-post`,
    postLike: `post-like`,
    getLikesById: `get-likes-by-id`,
    postComment: `post-comment`,
    getCommentsById: `get-comments-By-id`,
    deleteComment: `delete-comment`,
    updateComment: `update-comment`,
    getPost: 'get-post',
    getPostCounts: 'get-post-counts',
    addAnnouncement: 'add-announcement',
    getAnnouncement: 'get-announcement',
    updateAnnouncement: 'update-announcement',
    deleteAnnouncement: 'delete-announcement',
    getPopUpAnnouncement: 'get-popup-announcement',
    getWebcast: 'get-webcast',
    getAllAnnouncement: "get-all-announcement",
    getAlertAnnouncement: "get-alert-announcement"
  },
  kudos: {
    addKudosCategory: 'add-kudos-category',
    getKudosCategory: 'get-kudos-category',
    createKudos: 'create-kudos-request',
    getKudosData: 'get-kudos-request',
    addKudosPointHistory: 'add-kudos-point-history',
    getPointStatement: 'get-point-statement',
    getUserKudosOnType: 'get-user-type-approve-kudos',
    approveRejectKudos: 'approve-reject-kudos'
  },

  feedback: {
    createFeedbackTeam: `create-feedback-team`,
    getAllFeedbackTeams: 'get-all-feedback-teams',
    createFeedback: 'create-feedback',
    givenFeedback: 'given-feedback',
    getReceivedFeedbackOnFilter: 'get-received-feedback-on-filter',
    getFeedbackDashboardData: 'get-feedback-dashboard-data'

  },
  payroll: {
    getEmployeeDetailsByPayDays: "get-employee-details",
    getAttendanceStatus: `get-attendance-status`,
    updateAttendanceTracking: `update-attendance-tracking`,
    addEarnings: "add-earning",
    updateEarnings: "update-earning",
    addDeductions: "add-deduction",
    updateDeductions: "update-deductions",
    getEarnings: "get-earning",
    getDeductions: "get-deduction",
    addTaxSlabs: "add-tax-slabs",
    addEarningTypes: "add-earning-type",
    updateEarningTypes: "update-earning-type",
    getEarningType: "get-earning-type",
    getAllEarningType: "get-all-earning-type",
    getEarningTypeById: "get-earning-type-by-id",
    addDeductionTypes: "add-deductions-type",
    updateDeductionTypes: "update-deduction-type",
    getDeductionType: "get-deduction-type",
    getAllDeductionType: "get-all-deduction-type",
    getDeductionTypeById: "get-deduction-type-by-id",
    generateSalaryTemplate: 'generate-salary-template',
    createSalaryTemplate: "create-salary-template",
    getAllSalaryTemplate: "get-all-salary-template",
    getSalaryTemplate: 'get-salary-template',
    updateSalaryTemplate: 'update-salary-template',
    getSalaryTemplateById: 'get-salary-template-by-id',
    getAllEarning: "get-all-earning",
    getAllDeduction: "get-all-deduction",
    calculateCtc: 'calculate-ctc',
    addArrears: 'add-arrears',
    getArrears: 'get-arrears',
    addEmployeeSalary: "add-employee-salary",
    getEmployeeSalary: 'get-employee-salary',
    updateEmployeeSalary: 'update-employee-salary',
    getAllEmployeeAssignStatus: 'get-all-employee-assign-status',
    addPayRun: "generate-salary",
    addPaySchedule: "add-pay-schedule",
    updatePaySchedule: "update-pay-schedule",
    upcomingPayrolls: "upcoming-payrolls",
    payRollNotification: "pay-run-notification",
    getPayRun: "get-pay-run",
    getPayRunDashboardData: "get-pay-run-Dashboard",
    getPayRunHistory: "get-pay-run-history",
    approvePayroll: "approve-payroll",
    addTaxSlab: "add-tax-slab",
    updateTaxSlab: "update-tax-slab",
    getTaxSlab: "get-tax-slab",
    getAllTaxSlab: "get-all-tax-slab",
    deleteTaxSlab: "delete-tax-slab",
    getAllEmployeeSalary: "get-all-employee-salary",
    getCandidateSalary: 'get-candidate-salary',

    /*  Investment api's */
    addEmployeeInvestment: 'add-employee-investment',
    getEmployeeInvestment: 'get-employee-investment',
    updateEmployeeInvestment: "update-employee-investment",
    deleteEmployeeInvestment: "delete-employee-investment",
    addInvestmentCategory: "add-investment-category",
    updateInvestmentCategory: "update-investment-category",
    getInvestmentCategory: "get-investment-category",
    getAllInvestmentCategory: "get-all-investment-category",
    deleteInvestmentCategory: "delete-investment-category",
    addInvestmentSubCategory: "add-investment-sub-category",
    updateInvestmentSubCategory: "update-investment-sub-category",
    getInvestmentSubCategory: "get-investment-sub-category",
    getAllInvestmentSubCategory: 'get-all-investment-sub-category',
    deleteInvestmentSubCategory: "delete-investment-sub-category",
    getAllInvestmentCategoryDetails: "get-all-investment-category-details",
    getEmployeeMonthlySalary: "get-employee-monthly-salary",
    generateSalarySlip: "generate-salary-slip",
    sendOfferLetter: "send-offer-letter",

    /* proof of investment */
    employeeInvestmentProof: 'employee-investment-proof',
    getEmployeeInvestmentProof: 'get-employee-investment-proof',
    updateEmployeeInvestmentProof: 'update-employee-investment-proof',
    deleteEmployeeInvestmentProof: 'delete-employee-investment-proof',
    commentInEmployeeInvestmentProof: 'comment-in-employee-investment-proof',

    /*Loan api */
    addLoans: 'add-loans',
    updateLoans: 'add-loans',
    getLoans: 'get-loans',

    /* Advance api */
    applyAdvance: 'apply-advance',
    getAdvanceApproval: 'get-advance-approval',
    getAdvanceRequest: 'get-advance-request',
    approvalRejectAdvance: "approval-reject-advance",

    updateEmployeeMonthlySalary: 'update-employee-monthly-salary',

    checkRuleFormula: 'check-rule-formula',


    deleteSalaryTemplate: 'delete-salary-template',
    deleteEarningType: 'delete-earning-type',
    deleteDeductionType: 'delete-deduction-type',
    deleteDeduction: 'delete-deduction',
    deleteEarning: 'delete-earning',
    getEmployeeMonthlyPaySlip:'get-employee-monthly-paySlip'
  },
  attendance: {
    createShift: `create-shift`,
    getShift: `get-shift`,
    getShiftById: `get-shift-by-id`,
    updateShift: `update-shift`,
    deleteShift: 'delete-shift',
    addShiftConfiguration: `create-shift-configuration`,
    getShiftConfigurationById: `get-shift-configuration-by-shiftid`,
    shiftAssign: `shift-assign`,
    addWeekOff: `add-week-off`,
    getEmployeeByShiftId: `get-employee-by-shiftId`,
    getAllShiftDetails: `get-all-shift-details`,
    employeeDeleteShift: `employee-delete-shift`,
    activeOrInactive: `active-or-inactive`,
    getEmployeeShiftDetailsById: `get-employee-shift-details`,

    addShiftCalendar: `add-shift-calendar`,
    updateShiftCalendar: `update-shift-calendar`,
    getShiftCalendar: `get-shift-calendar`,
    deleteShiftCalendar: `delete-shift-calendar`,

    selfAttendance: `self-attendance`,
    myTeamAttendance: `my-team-attendance`,
    allTeamAttendance: `all-team-attendance`,
    attendanceReport: `attendance-report`,
    getDepartmentWiseAttendance: 'get-department-wise-attendance',

    getCorrectionNotification: "get-correction-notification",

    attendanceLock: "attendance-lock",
    getAttendanceLock: "get-attendance-lock",
    updateAttendanceLock: "update-attendance-lock",
    getAllEmployeeAttendance:'get-all-employee-attendance'

  },

  //Employee Api's
  employee: {
    getEmployeeForReportingManager: `get-employee-for-reporting-manager`,
    getAllEmployee: `get-all-employee`,
    createEmployee: `create-employee`,
    getUserOnRole: `get-user-on-role`,
    getProfile: `get-profile`,
    getAllEmployeeList: `get-all-employee-list`,
    updateEmployeeDetails: "update-employee-details",
    bulkUploadEmployee: "bulk-upload-employee",
    aadhaarVerify: 'aadhaar-verify-by-employee',
    resumeParser: 'resume-parser',
    generateEmployeeId: "generate-employee-id",
    getEmployeeByDepartment: 'get-employee-by-department',
    getEmployeeHistory: 'get-employment-history',
    sendEmployeeCredentials: "send-employee-credentials",
    uploadProfile: 'upload-profile'
  },

  client: {
    addClient: 'add-client',
    updateClient: 'update-client',
    deleteClient: 'delete-client',
    getAllClient: "get-client",
    getClientDetails: "get-client-details",
    updateClientDetails: "update-client-details"
  },

  /* Roles Api */
  roles: {
    addRoles: 'create-role',
    getAllRoles: `get-role-list`,
    getAllRolesData: 'get-all-roles',
    updateRole: 'update-role',
    deleteRole: 'delete-role',
    assignRole: 'assign-role',
    getEmployeesByRole: 'get-employees-by-role'

  },

  mrf: {
    // mrf process api's
    createUpdateMrf: 'create-update-mrf',
    getInterviewerList: 'get-interviewer-list',
    getMrfDataById: 'get-mrf-by-id',
    submitDraftMrf: "submit-draft-mrf",
    getAllUserMrf: "all-mrf",
    getMrfDashboardAndHierarchy: "get-mrf-dashboard-and-hierarchy",
    getMrfForApproval: "get-mrf-for-approval",
    approveRejectMrf: "approve-reject-mrf",
    getAssignedInterview: `get-assigned-interview`

  },

  mrfInterview: {
    assignInterview: `assign-interview`,
    getAssignedInterview: `get-assigned-interview`,
    getInterviewr: `get-interviewer`,
    getQuestionByInterviewStage: `get-question-by-interview-stage`,
    fillFeedbackForm: `fill-feedback-form`,
    getInterviewDetailsById: `get-interview-details-by-id`,
  },


  location: {
    getLocationList: "get-location-list",
    createLocation: "create-location",
    updateLocation: "update-location",
    deleteLocation: "delete-location",
    getAllLocationsData: "get-locations",
    getAllCountriesList: `get-all-countries-list`,
    getAllStateFromCountryList: `get-all-state-from-country-list`,
    getCityListFromState: `get-all-city-from-state`,
    addEmployeeLocation: `add-employee-location`,
    getLocation: `get-location`,
    updateMultipleEmployeeLocation: 'update-multiple-employee-location',
    getAllCity: 'get-all-city',
    getAllCityFromCountry: 'get-all-city-from-country',
    getLocationByLetLog: 'get-location-by-let-log'
  },
  travelAndClaim: {
    createTravelApplication: "create-travel-application",
    getTravelRequest: "get-travel-request",
    getTravelApproval: 'get-travel-approval',
    updateTravelApplication: 'update-travel',
    deleteTravel: 'delete-travel',
    getTravelType: 'get-travel-type',
    addTravelType: 'add-travel-type',
    updateTravelType: 'update-travel-type',
    deleteTravelType: 'delete-travel-type',
    getAllTravelType: 'get-All-travel-type',
    travelRequestApproveReject: 'travel-request-approve-reject',
    createTravelAndClaimRule: 'create-travel-and-claim-rule',
    updateTravelAndClaimRule: 'update-travel-and-claim-rule',
    deleteTravelAndClaimRule: 'delete-travel-and-claim-rule',
    getTravelAndClaimRule: 'get-travel-and-claim-rule',
    getAllTravelAndClaimRule: 'get-all-travel-and-claim-rule',
    assignRule: 'assign-rule',
    getAssignRule: 'get-assign-rule',
    getTravelTypeById: 'get-travel-type-by-id',
    createClaim: 'create-claim-request',
    updateClaim: 'update-claim-request',
    deleteClaim: 'delete-claim-request',
    getClaim: 'get-claim-request',
    getClaimApproval: 'get-claim-approval',
    approveRejectClaim: 'approve-reject-claim-request',
    getAllTravelApprovalData: 'get-all-travel-approve'

  },

  pms: {
    createKra: 'create-kra',
    getKraDetails: 'get-kra-details',
    getAllKraDetailsData: 'get-all-kra-details',
    updateKraDetail: 'update-kra-detail',
    deleteKraDetail: 'delete-kra-detail',

    createKraParameter: 'create-kra-parameter',
    getKraParameter: 'get-kra-parameter',
    getAllKraParameterData: 'get-all-kra-parameter-details',
    updateKraParameter: 'update-kra-parameter',
    deleteKraParameter: 'delete-kra-parameter',

    createKPiDetails: 'create-kpi',
    getKpiDetails: 'get-kpi-details',
    getAllKpiDetailsData: 'get-all-kpi-details',
    updateKpiDetail: 'update-kpi-detail',
    deleteKpiDetail: 'delete-kpi-detail',

    createKraRatingTypeForDepartment: 'create-kra-rating-type-for-department',
    getKraRatingTypeForDepartment: 'get-kra-rating-type-for-department',
    getAllKraRatingTypeForDepartment: 'get-all-kra-rating-type-for-department',
    updateKraRatingTypeDepartment: 'update-kra-rating-type-for-department',
    deleteKraRatingTypeForDepartment: 'delete-kra-rating-type-for-department',

    createSelfRatingPermission: 'create-self-rating-permission',
    getSelfRatingPermission: 'get-self-rating-permission',
    getAllSelfRatingPermission: 'get-all-self-rating-permission',
    updateSelfRatingPermission: 'update-self-rating-permission',
    deleteSelfRatingPermission: 'delete-self-rating-permission',

    createAssignKra: 'assign-kra',
    getAssignKra: 'get-assign-kra',
    getAllAssignKra: 'get-all-assign-kra',
    updateAssignKra: 'update-assign-kra',
    deleteAssignKra: 'delete-assign-kra',
    updateEmployeeRatingDuration: "update-employee-rating-duration",
    giveRating: 'give-rating',
    getGivenRating: 'get-given-rating',
    getEmployeeByKra: 'get-employee-by-kra',
    getKraDetailsByEmployee: "get-kra-details-by-employee",
    getRatingWiseEmployee: "get-rating-wise-employee",
    getAverageRating: 'get-average-rating'

  },

  branches: {
    getAllBranches: "get-branch-list",
  },

  holidays: {
    createHolidays: "create-holidays",
    getHolidays: "get-holidays",
    updateHoliday: "update-holiday",
    deleteHoliday: "delete-holiday",
    downloadSample: "download-sample",
    uploadHoliday: 'upload-holiday',
  },

  dropdownMaster: {
    // filteredDropdown
    getFilteredDropdownData: `get-filtered-dropdown-data`,
    addDropdownData: `add-dropdown-data`,
    getAllDropdownData: `get-dropdown-data`,
    deleteDropdownData: `delete-dropdown-data`,
    updateDropdownData: `update-dropdown-data`,
    getDropdownMasterConstantData: `get-dropdown-masters-constant`,
    addMasterDropdownCategory: `add-master-dropdown-category`,
    getMasterDropdownCategory: `get-master-dropdown-category`,
    getAllMasterDropdownCategory: `get-all-master-dropdown-category`,
    updateMasterDropdownCategory: `update-master-dropdown-category`,
    deleteMasterDropdownCategory: `delete-master-dropdown-category`,

  },
  leaveManagement: {
    applyAttendanceCorrection: 'apply-attendance-correction',
    getAttendanceCorrectionRequest: `get-attendance-correction-request`,
    approveRejectAttendanceCorrection: `approve-reject-attendance-correction`,
    getAttendanceCorrectionApproval: `get-attendance-correction-approval`,
    updateAttendanceLog: `update-attendance-log`,
    getAttendanceLogs: `get-attendance-logs`,
    attendanceCorrectionLogs: 'calculate-correction-logs',

    // Comp Off
    getCompOffData: "get-comp-off",
    approveRejectCompOff: "approve-reject-comp-off",

    // Tour
    applyTour: "apply-tour",
    getTourData: 'get-tour-request',
    getTourApproval: 'get-tour-approval',
    approveRejectTour: 'approve-reject-tours',

    getLeaveToday: "get-leave-today",
    getEmployeeLeave: 'get-employee-leave',

    getLeaveLedger: "get-leave-ledger",
    getLeaveLedgerReport: "get-leave-report",


  },

  dashboard: {
    employeeRequestPending: 'employee-request-pending',
    employeeCorrectionCount: 'employee-correction-count',
    employeeWeeklyAttendanceTrend: 'employee-weekly-attendance-trend',
    employeeAttendanceStatistics: 'employee-attendance-statistics',
    employeeLeavesStatistics: 'employee-leaves-statistics',
    getAnnouncementCount: 'get-announcement-count',
    employeeAttendanceCount: 'employee-attendance-count',
    employeeAttendance: 'employee-attendance',
    getEmployeeAttendanceStatus: 'get-employee-attendance-status',
    employeeLeaveOrTimeOff: 'employee-leave-or-time-off',
    todayPresentEmployee: 'today-present-employees'
  },

  taskManagement: {
    getAllTasks: 'get-task',
    createTask: 'add-task',
    updateTask: 'update-task',
    deleteTask: 'delete-task',

    getAllSubTasks: 'get-sub-task',
    createSubTask: 'add-sub-task',
    updateSubTask: 'update-sub-task',
    deleteSubTask: 'delete-sub-task',

    addTaskProject: 'add-task-project',
    getTaskProject: 'get-task-project',
    getAllTaskProjectList: 'get-all-task-project',
    updateTaskProject: 'update-task-project',
    deleteTaskProject: 'delete-task-project',

    getTaskLogs: 'get-task-logs',
    saveTimeTracking: 'save-time-tracking',
    taskReport: 'task-report',

    taskStatus: 'task-status',
    employeeWiseTask: 'employee-wise-task',
    taskGraph: 'task-graph',
    changeStatus: 'change-status',
    changeDueDate: 'change-due-date',
    addTaskFile: 'add-task-file',
    getTaskFile: 'get-task-file',

    subTaskStatus: 'sub-task-status',
    getMyTask: 'get-my-task'

  },

  permissios: {
    getMenuPermission: `get-menu-permission`
  },

  separation: {
    applySeparation: `apply-separation`,
    updateSeparation: 'update-separation',
    getSeparation: 'get-separation-request',
    getSeparationApproval: 'get-separation-approval',
    approveRejectSeparation: 'approve-reject-separation-request',
    getClearanceQuestion: "",
    applyClearanceForm: 'add-clearance-data',
    separationDetails: 'employee-separation-details',
    getClearance: 'get-clearance-form'
  },


  country: {
    add: '/country',
    list: '/country/list',
    getById: '/country',
    update: '/country',
    delete: '/country'
  },
  onBoard: {
    list: '/org/onBoard',
  },
  onboarding: {
    onboarding: `save-onboarding-details`,
    uploadDocuments: `upload-emp-documents`,
    getAllEmpDocuments: `get-employee-docs`,
    getAllOnbaordingSteps: `get-onboarding-step`,
  },

  // candidate
  candidate: {
    createCandidate: `create-candidate`,
    getAllCandidates: `all-candidates`,
    updateCandidateDetails: 'update-candidate-details'
  },
  assets: {
    addAssets: 'create-asset-inventory',
    getAllAssetsList: 'get-all-asset-inventory',
    getAssets: 'get-asset-inventory',
    updateAssets: 'update-asset-inventory',
    deleteAssets: 'delete-asset-inventory',
    assetsInStock: 'assets-in-stock',
    assignAssetToEmployee: 'assign-asset',
    getAssignAsset: 'get-assigned-assets',
    releaseAssets: 'assign-asset',
    assetUndertaking: 'add-under-taking',
    getAssetUndertaking: 'get-under-taking',
    assetRequest: 'apply-asset-request',
    getAssetRequestData: 'get-asset-request',
    assignedAsset: 'assign-asset',
    myAsset: 'my-asset',
    getAssetApproval: 'get-asset-approval',
    approveAssetRequest: 'approve-asset-request',
    getUnderTaking: "get-under-taking",
    assetSummary: 'asset-summary',
    cancelAssetRequest: 'cancel-asset-request',
    teamAsset: 'team-asset'
  },

  ticketManagement: {
    createTicket: 'create-ticket',
    getTicket: 'get-ticket',
    getAllTicket: 'get-all-ticket',
    updateTicket: 'update-ticket',
    deleteTicket: 'delete-ticket',
    createTicketIssueType: 'create-ticket-issue-type',
    getAllTicketType: 'get-ticket-issue-type',
    getTicketIssueSubType: 'get-ticket-issue-sub-type',
    getAllTicketIssueType: 'get-all-ticket-issue-type',
    updateTicketType: 'update-ticket-issue-type',
    deleteTicketType: 'delete-ticket-issue-type',
    createTicketLogs: 'ticket-logs',
    getTicketLogs: 'get-ticket-logs',
    getAllTicketLogs: 'get-all-ticket-logs',
    updateTicketLogs: 'update-ticket-log',
    deleteTicketLogs: 'delete-ticket-logs',
    createTicketSetting: 'ticket-setting',
    getTicketSetting: 'get-ticket-setting',
    getAllTicketSetting: 'get-all-ticket-setting',
    updateTicketSetting: 'update-ticket-setting',
    deleteTicketSetting: 'delete-ticket-setting',
    getTicketSummary: 'get-Summary',


    //HelpDesk
    createHelpDesk: 'create-helpDesk',
    getHelpDesk: "get-helpDesk",
    getAllHelpDesk: "get-all-helpDesk",
    updateHelpDesk: "update-helpDesk",
    deleteHelpDesk: "delete-helpDesk"
  },
  notification: {
    updateNotification: 'update-notification',
    deleteNotification: 'delete-notification',
    deleteAllNotification: 'delete-all-notification',
    getNotification: 'get-notification',
    getNotificationEvents: 'get-notification-events',
    updateCommunication: "update-communication"
  },
  moodRating: {
    saveMoodRating: 'save-mood-rating',
    getAllMoodRating: 'get-all-mood',
    findAllMoodRating: 'find-all-rating',
    findDailyMoodRating: 'find-daily-mood-rating',
    ratingPercent: 'rating-percent',
    dayWiseCoverage: 'day-wise-coverage',
    keyFunctionData: 'key-function-data',
    keyEmployeeData: 'key-employee-data'
  },
  bulkUpload :{
    bulkUploadEmployeeDetails :'bulk-upload-employee-details',
    downloadBulkUploadSampleFileRequest:'download-employee-sample'
  },
  reports: {
    salaryReport: "salary-report"
  }

};

export {
  baseUrls, apiUrls
};


